import context from '@/context'
import { allowErrorDialog } from '@/utils/fetch'
import getComponentKey from '@/utils/getComponentKey'

export const initialState = {
  fetching: false,
  updating: false,
  language: 'en',
  componentKey: getComponentKey()
}

export const actionTypes = {
  fetching: 'languageSettings/fetching',
  fetched: 'languageSettings/fetched',
  updating: 'languageSettings/updating',
  updated: 'languageSettings/updated',
  error: 'languageSettings/error'
}

export const actionCreators = {
  get: () => (dispatch) => {
    dispatch({ type: actionTypes.fetching })
    context.api.userProfile.getLanguagePreferrence(allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetched, payload: response })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { fetching: false } }))
  },
  update: (language) => (dispatch) => {
    dispatch({ type: actionTypes.updating })
    context.api.userProfile.setLanguagePreferrence({ language }, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.updated })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { updating: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return { ...state, fetching: false, language: action.payload.language, componentKey: getComponentKey() }

    case actionTypes.updating: return { ...state, updating: true }
    case actionTypes.updated: return { ...state, updating: false }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/languageSettings.js